import ModuleWindow from './ModuleWindow';

const HeadlessModule = (props: any) => {
    const { tradingModule } = props;

    return <ModuleWindow {...props}>{tradingModule?.component}</ModuleWindow>;
};

export default HeadlessModule;
